<script setup lang="ts">
import axios from 'axios'
import { useAppStore } from '@/stores/app'
import { useAuthStore } from '@/stores/auth'
import { useOrganisationSaveSettings } from '@/composable/queries/Dara/organisation'

const appStore = useAppStore(),
  authStore = useAuthStore()

const saveSettings = useOrganisationSaveSettings()

const close = (() => {
  appStore.showMyHQWelcomeModal = false

  const data = {
    default_locale: authStore.organisation?.default_locale,
    is_duplex_printing_enabled: authStore.organisation?.is_duplex_printing_enabled,
    myhq_version: 'new',
    notification_low_licence: authStore.organisation?.notification_settings.low_licences,
    report_name: authStore.organisation?.report_name,
    timezone: authStore.organisation?.timezone,
    year_sub_group_known_as: authStore.organisation?.year_sub_group_known_as,
  }

  saveSettings.mutate(data,
    {
      onError: error => {
        interface ErrorResponse {
          errors: {
            [key: string]: string[]
          }
          message: string
        }
        if(
          axios.isAxiosError(error)
          && error.response
          && error.response
          && error.response.status === 422
        ) {
          const responseData = error.response.data as ErrorResponse

          appStore.setSnackbar({
            colour: 'error',
            text: responseData.message,
          })
        }
      } })
})
</script>

<template>
  <VDialog
    v-model="appStore.showMyHQWelcomeModal"
    width="800"
    @click:outside="close"
  >
    <VCard class="pa-2">
      <VCardTitle class="pl-5">
        {{ $t('pages.dashboard.new_myhq_modal.title') }}
      </VCardTitle>
      <VCardText>
        <p class="mb-3">
          {{ $t('pages.dashboard.new_myhq_modal.text_1') }}
        </p>
        <p class="mb-3 text-center">
          -----
        </p>
        <p
          v-dompurify-html="$t('pages.dashboard.new_myhq_modal.text_2')"
          class="mb-3"
        />
        <p class="mb-3 text-center">
          -----
        </p>
        <p v-dompurify-html="$t('pages.dashboard.new_myhq_modal.text_3')" />
      </VCardText>
      <VCardActions class="d-flex justify-center">
        <VBtn
          color="primary"
          rounded="xl"
          variant="elevated"
          :text="$t('general.ok')"
          @click="close"
        />
      </VCardActions>
    </VCard>
  </VDialog>
</template>
